import { useParams } from "react-router-dom";
import { CertificadoShell, GenderLabLoader } from "../../components";
import { useEffect, useState } from "react";
import { aulaService } from "../../api";
import { TStudentCertificateData } from "../../types";

export const CertificadoAlumnoAulaPage = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [certificateData, setCertificateData] =
    useState<TStudentCertificateData | null>(null);
  const [triggerDownload, setTriggerDownload] = useState(false);

  useEffect(() => {
    const shouldTriggerDownload =
      sessionStorage.getItem("triggerDownload") === "true";
    if (shouldTriggerDownload) {
      sessionStorage.removeItem("triggerDownload");
      setTriggerDownload(true);
    }

    const getData = async () => {
      try {
        if (id) {
          const response = await aulaService.getEnrollmentCertificateData(id);
          setCertificateData(response.data);
        }
      } catch (e) {
        console.error("Error al cargar el certificado", e);
      } finally {
        setLoading(false);
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <GenderLabLoader />;
  }

  if (!certificateData) {
    return <div>Ha ocurrido un error al cargar el certificado.</div>;
  }

  return (
    <CertificadoShell
      nombreEmpresa={certificateData.student_name}
      nombreCurso={certificateData.client_trade_name}
      customHeader="certificado de participación otorgado a:"
      fecha={certificateData.completed_at}
      triggerDownload={triggerDownload}
    >
      Por haber completado al 100% el curso{" "}
      <b>{certificateData.course_title}</b> en el Aula Virtual de ELSA.
    </CertificadoShell>
  );
};
